var ils;
(function (ils) {
    let MapsGACategories;
    (function (MapsGACategories) {
        MapsGACategories["StaticMaps"] = "G-Static Maps";
        MapsGACategories["DynamicMaps"] = "G-Dynamic Maps";
    })(MapsGACategories = ils.MapsGACategories || (ils.MapsGACategories = {}));
    ils.googleMapsApiLoaded = false;
    ils.googleDynamicMapsLoaded = false;
    ils.googleDynamicMapsIsLoading = false;
    ils.googleStaticNeighborhoodMapLoaded = false;
    ils.googleStaticCommunityMapLoaded = false;
})(ils || (ils = {}));
